module.exports = __webpack_public_path__ + "static/img/about_company_banner_cn.7b92be4b.jpg";